import { SvgIcon } from '@mui/material';

import getMuiIcon, { type IconName } from './getMuiIcon';

export const renderToolbarIcon = (
	iconName: IconName,
	color: string,
	ariaHidden = true,
	viewBox = '0 0 16 16'
) => (
	<SvgIcon
		component={getMuiIcon(iconName)}
		sx={{ color, width: 16, height: 16 }}
		viewBox={viewBox}
		aria-hidden={ariaHidden}
		data-testid={`toolbar-icon-${iconName}`}
	/>
);
